import { createSelector } from 'reselect'
import { getPageData } from 'selectors/page'

export const getSlugifyDictionary = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.slugifyDictionary || {}
)

export const getSelectedFacets = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.selectedFacets || {}
)
